import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/";
import JsEncrypt from "jsencrypt";
import "@/libs/request";
import config from "@/config/";
// element-ui
import elementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/scss/element-variable.scss";
// vue-quill-editor
import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
// highlight
import Highlight from "./libs/highlight";
// scroll
import infiniteScroll from "vue-infinite-scroll";
// oss
import OSS from "ali-oss";
// lea-ui
import { install } from "./modules/index";

import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/";
import SectionHeader from "@/components/SectionHeader/";

import BaiduMap from "vue-baidu-map";
import ViewModel from "@/modules/viewmodel/ViewModel";
import bus from "@/libs/Bus/";

Vue.prototype.$bus = bus;
Vue.prototype.$jsencrypt = JsEncrypt;
Vue.prototype.$config = config;
Vue.prototype.$oss = OSS;
Vue.prototype.$viewModel = new ViewModel();

Vue.config.productionTip = false;
Vue.use(elementUI);
Vue.use(VueQuillEditor);
Vue.use(Highlight);
Vue.use(infiniteScroll);
Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  ak: "9TYU1o0SVpc4ySBWYCIcsCcZWYFEdd4I"
});
install(Vue);

// register common component
Vue.component("pai-header", Header);
Vue.component("custom-footer", Footer);
Vue.component("section-header", SectionHeader);

window.addEventListener("resize", () => {
  store.commit("setIsMobile", window.innerWidth <= 991);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
